import { GetVideoResponseType } from "../../../hooks/useGetVideo";
import { Label } from "@/components/ui/label";
import DeleteVideoButton from "./deleteButton";
import DownloadButton from "./downloadButton";
import EditVideoButton from "./editButton";
import { t } from "@/lib/localization";

export default function VideoSheetHeader({
    video,
}: {
    video: GetVideoResponseType["data"];
}) {
    return (
        <header className="bg-white px-4 flex flex-row h-16 w-full justify-between items-center border-b">
            <div className="truncate flex flex-col">
                <Label className="truncate text-base">
                    {video?.title
                        ? t("video-sheet.header.title", undefined, {
                              videoTitle: video.title,
                          })
                        : t(
                              "video-sheet.header.title.placeholder",
                              undefined,
                              undefined
                          )}
                </Label>

                {!!video?.folders.length && (
                    <p
                        className="truncate text-xs text-muted-foreground"
                        title={video.folders.map((f) => f.name).join(", ")}
                    >
                        {t("video-sheet.header.folders", undefined, {
                            folderNames: video.folders
                                .map((f) => f.name)
                                .join(", "),
                        })}
                    </p>
                )}
            </div>

            <div className="hidden md:flex flex-row gap-2">
                <EditVideoButton videoId={video.id} />
                <DownloadButton
                    videoId={video.id}
                    videoTitle={video.title}
                    originalFileFormat={video.originalFileFormat}
                    dubbings={video.dubbings}
                    captions={video.captions}
                />
                <DeleteVideoButton video={video} />
            </div>
        </header>
    );
}
